import { customAlphabet } from "nanoid";
import {
  xhrHookEnable,
  xhrHookGetInstance
} from "src/app/libs/xhr-hook/xhr-hook";

const alphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(alphabet, 24);

let memberToken: string | undefined;

export function enableHXRStorageMemberToken(token: string): void {
  memberToken = token;
}

export function registerHXRInterceptors({
  ignoreUrls
}: {
  ignoreUrls: string[];
}): void {
  xhrHookEnable({ ignoreUrls });

  const xhook = xhrHookGetInstance();

  xhook.before((request: any) => {
    if (!request) {
      return;
    }

    if (request.url.indexOf("snoots-storage-staging-filebucket") >= 0) {
      return;
    }

    if (!request.headers) {
      request.headers = {};
    }
  });

  xhook.before((request: any) => {
    if (!request) {
      return;
    }

    if (request.url.indexOf("snoots-storage-staging-filebucket") >= 0) {
      return;
    }

    if (
      !!request.headers &&
      (!!request.headers["member"] || !!request.headers["Member"])
    ) {
      return;
    }

    if (!!memberToken) {
      if (
        request.url &&
        (request.url.indexOf("storage.staging.snoots.pet") >= 0 ||
          request.url.indexOf("storage.snoots.pet") >= 0)
      ) {
        request.headers["member"] = `Bearer ${memberToken}`;
      }
    }
  });
}
